import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {FormCardSection} from '@/components/ui/form-atoms/FormAtoms'
import {AlertCircleIcon, CheckCircleIcon} from '@/components/ui/icon/Icon'
import {Text} from '@/components/ui/text/Text'
import {PLANNED_ACCESSES_MEDICAL_THRESHOLD} from '@/features/planned-accesses/utils'
import {useTranslation} from '@/translations/i18n'
import {useMemo} from 'react'
import {useTheme} from 'styled-components'

export const PlannedAccessesMedicalCard = ({
    totalTreatmentAccessesCount,
    totalMedicalAccessesCount
}: {
    totalTreatmentAccessesCount: number
    totalMedicalAccessesCount: number
}) => {
    const {palette} = useTheme()
    const {t} = useTranslation()
    const totalThreshold = Math.round((totalTreatmentAccessesCount * PLANNED_ACCESSES_MEDICAL_THRESHOLD) / 100)

    const percentageIncidence = useMemo(() => {
        if (!totalMedicalAccessesCount || !totalTreatmentAccessesCount) return 0
        return Number(((totalMedicalAccessesCount / totalTreatmentAccessesCount) * 100).toFixed(2))
    }, [totalMedicalAccessesCount, totalTreatmentAccessesCount])

    return (
        <FormCardSection columns={2} padding={3}>
            <Flexbox direction="column" gap={1.5}>
                <Flexbox align="center" gap={1}>
                    <Text size="textSm" palette="neutral" shade="600">
                        {t('planned_accesses:medical_accesses')}
                    </Text>
                    {totalMedicalAccessesCount >= 0 &&
                        (percentageIncidence >= PLANNED_ACCESSES_MEDICAL_THRESHOLD ? (
                            <CheckCircleIcon color={palette.success[500]} size={14} />
                        ) : (
                            <AlertCircleIcon color={palette.orange[500]} size={14} />
                        ))}
                </Flexbox>
                <Text weight="500" size="textSm">
                    {totalMedicalAccessesCount}{' '}
                    <Text render="span" size="textSm" palette="neutral" shade="500">
                        ({percentageIncidence}%)
                    </Text>
                </Text>
            </Flexbox>
            <Flexbox direction="column" gap={1.5}>
                <Text size="textSm" palette="neutral" shade="600">
                    {t('planned_accesses:medical_accesses_threshold')}
                </Text>
                <Text weight="500" size="textSm">
                    {totalThreshold || 0}{' '}
                    <Text render="span" size="textSm" palette="neutral" shade="500">
                        ({PLANNED_ACCESSES_MEDICAL_THRESHOLD}%)
                    </Text>
                </Text>
            </Flexbox>
        </FormCardSection>
    )
}
